export default "__VITE_ASSET__456dfa09__"